import { BookingData } from "../../AppDataProvider/AppDataProvider";
import { PartRequired } from "../../utils/types";

type BookingDataKey = keyof BookingData;

export type RecurringBookingStepBookingData = PartRequired<
  BookingData,
  | "attendees"
  | "createdSource"
  | "duration"
  | "organisation"
  | "recurringBooking"
  | "service"
  | "timezone"
>;

export const RequiredFields: BookingDataKey[] = [
  "createdSource",
  "organisation",
  "service",
  "timezone",
  "duration",
  "attendees",
  "recurringBooking",
];
